import cloneDeep from 'lodash/cloneDeep';
import widgetHelper from '../widget-utilities/widget-helper';

/* Config builder for table */
var tableConfigBuilder = function tableConfigBuilder() {

    // Modify PageNumber property in TableConfig
    var modifyPageNumber = function modifyPageNumber(pageNumber) {
        var modifiedPageNumber = pageNumber > 0 ? pageNumber.toString() : null;
        return modifiedPageNumber;
    };

    // Modify PageSize property in TableConfig
    var modifyPageSize = function modifyPageSize(pageSize) {
        var modifiedPageSize = pageSize > 0 ? pageSize.toString() : null;
        return modifiedPageSize;
    };

    // Modify PivotField Config in TableConfig
    var modifyPivotFieldConfig = function modifyPivotFieldConfig(pivotFieldConfig) {
        var modifiedPivotFieldConfig = pivotFieldConfig !== null ? pivotFieldConfig : null;
        return modifiedPivotFieldConfig;
    };

    // Modify ContainerClassName in TableConfig
    var modifyContainerClassName = function modifyContainerClassName(containerClassName) {
        var modifiedContainerClassName = containerClassName === null || containerClassName.trim().length === 0 ? '' : containerClassName;
        return modifiedContainerClassName;
    };

    // Modify Data in TableConfig
    var modifyTableData = function modifyTableData(data) {
        var dataProperties = ['pageCount', 'totalRowCount', 'sortOrders', 'pivotColumnData', 'data'];
        dataProperties.forEach(function (dataProperty) {
            data[dataProperty] = Object.prototype.hasOwnProperty.call(data, dataProperty) ? JSON.parse(data[dataProperty]) : null;
        });
        return data;
    };

    // Add ServiceName to config
    var addServiceName = function addServiceName(source) {
        var serviceName = source && source.ElementName && source.ElementName.length > 0 ? source.ElementName : null;
        return serviceName;
    };

    // Modify existing table config properties
    var modifyTableConfigProperties = function modifyTableConfigProperties(config) {
        var _config$TableConfig = config.TableConfig,
            ClassifierField = _config$TableConfig.ClassifierField,
            Source = _config$TableConfig.Source,
            PageNumber = _config$TableConfig.PageNumber,
            PageSize = _config$TableConfig.PageSize,
            PivotFieldConfig = _config$TableConfig.PivotFieldConfig,
            ContainerClassName = _config$TableConfig.ContainerClassName,
            Data = config.Data;


        config.TableConfig.ClassifierField = widgetHelper.initializeConfigPropertyWithEmptyString(ClassifierField);

        config.ServiceName = addServiceName(Source);
        config.TableConfig.PageNumber = modifyPageNumber(PageNumber);
        config.TableConfig.PageSize = modifyPageSize(PageSize);
        config.TableConfig.PivotFieldConfig = modifyPivotFieldConfig(PivotFieldConfig);
        config.TableConfig.ContainerClassName = modifyContainerClassName(ContainerClassName);
        config.Data = modifyTableData(Data);
        return config;
    };

    // Remove unwanted properties, add custom properties and initialize null/undefined values
    var configBuilder = function configBuilder(config) {

        // Modify common widget config properties
        config = widgetHelper.modifyWidgetConfigProperties(cloneDeep(config));

        // Modify table specific config properties
        config = modifyTableConfigProperties(cloneDeep(config));

        return config;
    };

    return {
        configBuilder: configBuilder
    };
};

export default tableConfigBuilder();